import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12e237ff&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=12e237ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e237ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e237ff')) {
      api.createRecord('12e237ff', component.options)
    } else {
      api.reload('12e237ff', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12e237ff&scoped=true&", function () {
      api.rerender('12e237ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/btn/index.vue"
export default component.exports